import { render, staticRenderFns } from "./Dismiss.vue?vue&type=template&id=53610764"
import script from "./Dismiss.vue?vue&type=script&lang=ts"
export * from "./Dismiss.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports